import http from 'axios';
import base64 from 'base-64';
import { API_URL, API_URL_POST, FUNCTION_KEY } from '../runtimeConfig';


export const ShoppingCartService = () => {
    let shoppingCart = {
        items: [],
    };

    const mapCartResponse = (data) => {
        if (!data) return { items: [], totalPrice: '€ 0.00' };
        
        const items = data.items || data.Items || [];
        const mappedItems = items.map(item => ({
            productId: item.productId || item.ProductId,
            productName: item.productName || item.ProductName,
            description: item.description || item.Description,
            quantity: item.quantity || item.Quantity,
            price: item.price || item.Price,
            total: item.total || item.Total,
            totalPrice: item.totalPrice || item.TotalPrice,
        }));
        
        return {
            items: mappedItems,
            totalPrice: data.totalPrice || data.TotalPrice || '€ 0.00',
            customerId: data.customerId || data.CustomerId,
        };
    };

    const getShoppingCart = async () => {
        const url = API_URL + '/shop/cart/active';
        try {
            
            const res = await http.get(url);
                shoppingCart = mapCartResponse(res.data);
                return shoppingCart;
        } catch (err) {
            console.log(err);
            return { items: [], totalPrice: '€ 0.00' };
        }
    };

    const removeTotalItem = async (item) => {
        const url = API_URL_POST + `/shop/cart/active/items/${base64.encode(item.productId)}?quantity=all` + '&code=' + FUNCTION_KEY;

        try {
            const res = await http.delete(url);
            shoppingCart = mapCartResponse(res.data);
            return shoppingCart;
        } catch (err) {
            console.log(err);
            return { items: [], totalPrice: '€ 0.00' };
        }
    }

    const removeItem = async (item) => {
        const url = API_URL_POST + `/shop/cart/active/items/${base64.encode(item.productId)}` + '?code=' + FUNCTION_KEY;

        try {
            const res = await http.delete(url);
            shoppingCart = mapCartResponse(res.data);
            return shoppingCart;
        } catch (err) {
            console.log(err);
            return { items: [], totalPrice: '€ 0.00' };
        }
    }

    const addItem = async (itemId, quantity) => {
        const url = API_URL_POST + '/shop/cart/active/items' + '?code=' + FUNCTION_KEY;

        try {
            const res = await http.post(url, {id: itemId, quantity});
            shoppingCart = mapCartResponse(res.data);
            return shoppingCart;
        } catch (err) {
            console.log(err);
            return { items: [], totalPrice: '€ 0.00' };
        }
    }

    const startCheckout = async () => {
        const url = API_URL_POST + '/shop/checkout' + '?code=' + FUNCTION_KEY;
        try {
            const res = await http.post(url);
            return res.data;
        } catch (err) {
            console.log(err);
            return {
                success: false,
                message: err.message,
            }
        }
    }

    const placeOrder = async (orderData = {}) => {
        const url = API_URL_POST + '/shop/order' + '?code=' + FUNCTION_KEY;
        try {
            const res = await http.post(url, orderData);
            const data = res.data || {};
            return {
                ...data,
                activeShoppingCart: mapCartResponse(data.activeShoppingCart || data.ActiveShoppingCart),
            };
        } catch (err) {
            console.log(err);
            return {
                success: false,
                message: err.message,
            }
        }
    }

    const clearCart = async () => {
        const url = API_URL_POST + '/shop/cart/active' + '?code=' + FUNCTION_KEY;
        try {
            const res = await http.delete(url);
            shoppingCart = mapCartResponse(res.data);
            return shoppingCart;
        } catch (err) {
            console.log(err);
            return { items: [], totalPrice: '€ 0.00' };
        }
    }

    return { getShoppingCart, removeItem, addItem, startCheckout, placeOrder, clearCart, removeTotalItem };
}

